import { section } from "@/glow";
import { qs, listen } from "@fluorescent/dom";
import { animateStandard, shouldAnimate } from "@/lib/animation";

const selectors = {
  collectionListButtonsInner: ".collection-list-buttons__inner",
  expandButton: ".collection-list-buttons__expand-button",
};

section("collection-list-buttons", {
  onLoad() {
    const expandButton = qs(selectors.expandButton, this.container);
    const collectionListButtonsInner = qs(
      selectors.collectionListButtonsInner,
      this.container
    );

    this.events = [];

    if (expandButton) {
      this.events.push(
        listen(expandButton, "click", e => {
          e.preventDefault();
          collectionListButtonsInner.dataset.expanded = true;
        })
      );
    }

    if (shouldAnimate(this.container)) {
      this.animateCollectionListButtons = animateStandard(
        this.container
      );
    }
  },

  onUnload() {
    this.events.forEach(unsubscribe => unsubscribe());
    this.animateCollectionListButtons?.destroy();
  },
});
